import './index.scss';

import { ChangeEvent, Component, ReactNode } from 'react';

import { UncontrolledField } from '..';
import { BraxIcon } from '../../BraxIcon';
import { BraxUncontrolledField } from '../BraxUncontrolledField';

export type BraxUncontrolledColorPickerFieldProps = UncontrolledField<string> & {
    label: ReactNode,
    hint?: ReactNode,
    required?: boolean,
    onChange?: (value: string, event: ChangeEvent<HTMLInputElement>) => void
};

export class BraxUncontrolledColorPickerField extends Component<BraxUncontrolledColorPickerFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    change(event: ChangeEvent<HTMLInputElement>) {
        this.props.onChange?.(event.target.value, event);
    }

    render() {
        const { id, label, value, required, status, hint, onChange, ...props } = this.props;

        return (
            <BraxUncontrolledField id={id}>
                { ({ id }) => (
                    <div className={`brax-color-picker-field ${status}`}>
                        <label htmlFor={id}>
                            <span>{ label } { required ? '*' : null }</span>

                            <span>
                                <input
                                    id={id}
                                    type="color"
                                    value={value}
                                    onChange={event => this.change(event)}
                                    {...props}
                                />
                            </span>

                            <span>{ value }</span>
                        </label>

                        { hint ? (
                            <p className="hint">
                                { status === 'error' ? <BraxIcon icon="exclamation-mark" /> : null }

                                <span>{ hint }</span>
                            </p>
                        ) : null }
                    </div>
                ) }
            </BraxUncontrolledField>
        );
    }

}
